import 'url-search-params-polyfill';

export function getTrackingCode() {
  const params = new URLSearchParams(window.location.search);
  return params.get('t');
}
